import { Injectable, NgZone } from '@angular/core';
import { HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { NotificacaoService } from "./notificacao.service";
import { AccessToken } from "../models/access-token";
import { globals } from "../globals";
import { ICFeedItem } from "../models/ic/ic-feed-item";
import { ICService } from "./ic.service";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { NotificacaoSignalr } from "../notificacao/services/notificacao.signalr";

@Injectable({
  providedIn: 'root'
})
export class SolaryumHubV1Service {
  private connection: HubConnection = null;

  constructor(
    private router: Router,
    private notificacaoService: NotificacaoService,
    private notificacaoSignalr: NotificacaoSignalr,
    private iCService: ICService,
    private ngZone: NgZone,
  ) { }

  public startConnection = (accessToken?: AccessToken) => {
    if (accessToken === null) {
      return;
    }

    this.connection = new HubConnectionBuilder()
      .configureLogging(LogLevel.Warning)
      .withUrl(globals.apiUrl + '/hub-v1', {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
        accessTokenFactory: () => accessToken.accessToken,
      })
      .withAutomaticReconnect()
      .build();

    // Inicializando monitor de eventos
    this.notificacaoSignalr.start(this.connection);


    //
    // Eventos antigos
    //

    // Logout
    this.connection.on("logout", (data) => {
      this.router.navigate(["/login"]).then();
    });

    this.connection.on('ic_feedItem', (data: ICFeedItem) => {
      this.iCService.salvarFeedItem(data);
    });

    this.connection.on('progresso', (data) => {
      this.ngZone.run(() => {
        this.notificacaoService.atualizacaoProgresso.next(data);
      });
    });

    this.connection.start().catch(err => {
      if (!environment.production) {
        console.error(`Erro no SignalR: ${err.message}`);
      }
    });
  };

  public closeConnection() {
    if (this.connection === null) {
      return;
    }

    // Encerrando monitor de eventos
    this.notificacaoSignalr.stop();

    this.connection.stop().then(() => {
      this.connection = null;
    });
  }
}
